<script>
import SkeletonBase from '@/packages/ui/components/Skeleton/SkeletonBase.vue';

export default {
  name: 'TableSkeleton',
  components: { SkeletonBase },
};
</script>

<template>
  <SkeletonBase
    height="24px"
    spacing="0"
    width="100%"
  />
</template>
